import * as React from "react";
import { ProductAmount } from "./ProductAmount";
import { ProductShownStats } from "./ProductShowStats";
export var ProductStats = function (_a) {
    var item = _a.item, maxStorage = _a.maxStorage, className = _a.className;
    return (React.createElement("div", { className: className },
        React.createElement(ProductAmount, { maxStorage: maxStorage, item: item }),
        React.createElement(ProductShownStats, { item: item })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/farm-management/ProductStats.tsx
// module id = 927
// module chunks = 3